import { Role, useAuthStore, userProfileSelector } from 'modules/auth/core';
import { TeamRole } from 'modules/team';

export const getDevicePermission = (role?: TeamRole, requiredRole = TeamRole.TeamGuest) => {
  const userProfile = userProfileSelector(useAuthStore.getState());
  const isAdminUser = userProfile?.role_id === Role.Admin;

  return Number(role) < Number(requiredRole) || isAdminUser;
};
